var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"info"},[_c('p',[_vm._v("双击编辑待办事项")]),_c('p',[_vm._v("管理工作和生活todolist")]),_c('p',[_vm._v("todolist")])])}]

export { render, staticRenderFns }